import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { id: "mainContainer" }
const _hoisted_2 = { class: "mid-container" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "customers-section" }
const _hoisted_5 = { class: "container" }
const _hoisted_6 = { class: "customers-inner" }
const _hoisted_7 = { class: "custom-row" }
const _hoisted_8 = { class: "flip-card" }
const _hoisted_9 = { class: "flip-card-inner" }
const _hoisted_10 = { class: "flip-card-front" }
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "flip-card-back" }
const _hoisted_13 = { class: "flip-card-back-inner" }
const _hoisted_14 = { class: "flip_txt" }
const _hoisted_15 = {
  key: 0,
  class: "url_btn"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_userHeader = _resolveComponent("userHeader")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_userFooter = _resolveComponent("userFooter")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_userHeader, { ref: "userHeader" }, null, 512),
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("section", {
        class: "page-banner-section",
        style: _normalizeStyle({ 'background-image': `url(${require('@/assets/images/clients-banner.jpg')})` })
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h1", null, _toDisplayString(_ctx.constants['MEET_OUR_CUSTOMERS_TEXT']), 1)
        ])
      ], 4),
      _createElementVNode("section", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("h2", null, _toDisplayString(_ctx.constants['OUR_CLIENTS_TEXT']), 1),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.clientsData, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "customers-box",
                  key: index
                }, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("img", {
                          src: _ctx.getCdnImageAddress(item.companyLogo, `w_350,h_285/`),
                          alt: "Avatar"
                        }, null, 8, _hoisted_11)
                      ]),
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("div", _hoisted_13, [
                          _createElementVNode("h3", null, _toDisplayString(item.title), 1),
                          _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.useStripHtml(_ctx.getTruncatedText(_ctx.getClientDescription(item), 130))), 1),
                          (_ctx.shouldShowClientReadMore(item))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                _createVNode(_component_router_link, {
                                  to: `/client/${item.slug}`,
                                  id: "readMoewa",
                                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeMenu()))
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("Read More >>")
                                  ]),
                                  _: 2
                                }, 1032, ["to"])
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ])
                  ])
                ]))
              }), 128))
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_userFooter)
  ]))
}